import  { useState } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate, Link } from "react-router-dom";

const RoleCard = ({ label, description, isActive, onClick }) => {
  const activeBg = useColorModeValue("#E0F7F4", "#225E55");
  const inactiveBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("#38B2AC", "#4FD1C5");

  return (
    <Box
      as="button"
      onClick={onClick}
      flex="1"
      px={{ base: 4, md: 6 }}
      py={{ base: 4, md: 6 }}
      borderRadius="2xl"
      borderWidth="2px"
      borderColor={isActive ? borderColor : "transparent"}
      bg={isActive ? activeBg : inactiveBg}
      boxShadow="md"
      display="flex"
      flexDirection="column"
      _hover={{
        boxShadow: "lg",
        transform: "translateY(-2px)",
      }}
      transition="all 0.2s ease"
      textAlign="center"
      alignItems="center"
    >
      {/* <Box
        w="64px"
        h="64px"
        borderRadius="full"
        bg={useColorModeValue("#FEEBC8", "#744210")}
        mb={3}
      /> */}
      <Heading fontSize="lg" mb={1} textAlign="center">
        {label}
      </Heading>
      <Text fontSize="sm" color="gray.500" textAlign="center">
        {description}
      </Text>
    </Box>
  );
};

const Welcome = () => {
  const [selectedRole, setSelectedRole] = useState("client");
  const navigate = useNavigate();

  const navigation=()=>{


    if(selectedRole==='client')
      navigate("/client")
    else{
      navigate("/auth/signin")
    }
  }

  const cardBg = useColorModeValue("white", "gray.900");
  const pageBg = useColorModeValue("#E6F5F3", "gray.900");

  return (
    <Flex minH="100vh" bg={pageBg} align="center" justify="center" px={4}>
      <Container maxW="sm" px={0}>
        <Box
          bg={cardBg}
          borderRadius="3xl"
          boxShadow="2xl"
          overflow="hidden"
        >
          <Box
            h="160px"
            bgGradient="linear(to-b, teal.100, teal.50)"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={3}
          >
            <Box
              w="96px"
              h="96px"
              borderRadius="full"
              bg="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="lg"
            >
              <Image
                src="/logo.png"
                alt="لوگوی نروان"
                boxSize="72px"
                objectFit="contain"
              />
            </Box>
            <Text fontSize="sm" fontWeight="600" color="teal.700">
              مرکز مشاوره نارون سبز
            </Text>
          </Box>

          <Box px={{ base: 6, md: 8 }} py={6}>
            <Stack spacing={3} textAlign="center" mb={6}>
              <Heading fontSize="2xl" textAlign="center">نقش خود را انتخاب کنید</Heading>
              <Text fontSize="sm" color="gray.500">
                لطفاً مشخص کنید به عنوان مراجع وارد می‌شوید یا مدیر سامانه.
              </Text>
            </Stack>

            <Flex
              direction={{ base: "column", sm: "row" }}
              gap={4}
              mb={6}
            >
              <RoleCard
                label="مراجع"
                description="برای افرادی که از خدمات مشاوره استفاده می‌کنند."
                isActive={selectedRole === "client"}
                onClick={() => setSelectedRole("client")}
              />
              <RoleCard
                label="مدیر"
                description="برای مدیران و مسئولان سامانه."
                isActive={selectedRole === "admin"}
                onClick={() => setSelectedRole("admin")}
              />
            </Flex>

            <Button
              w="100%"
              colorScheme="teal"
              size="lg"
              borderRadius="full"
              mb={2}
              onClick={navigation}
            >
              شروع کنید
            </Button>

            {/* <Button
              as={Link}
              to="/auth/forms"
              w="100%"
              variant="outline"
              colorScheme="teal"
              size="md"
              borderRadius="full"
              mb={2}
            >
              پر کردن فرم‌های آنلاین
            </Button> */}

            
          </Box>
        </Box>
      </Container>
    </Flex>
  );
};

export default Welcome;

